import React, { cloneElement } from 'react';

import { StickyWrapper } from 'components/sticky-wrapper/StickyWrapper';

interface IProps {
  header: React.ReactElement;
  heading: string;
  children: React.ReactNode;
}

export const EventWrapper = ({ header, children, heading }: IProps) => {

  return (
    <StickyWrapper lead={cloneElement(header, { heading })}>
        {cloneElement(header, { heading, hidden: true})}
        {children}
    </StickyWrapper>
  );
};
